<template>
  <div class="chat-body">
    <div
      v-for="(item, index) in messages"
      :key="index"
      class="message-container"
    >
      <div v-if="item.sender === 'me'" class="bubbleBox">
        <div class="bubble">
          <!-- 如果是 loading 状态，显示 loading 动画 -->
          <div v-if="item.isLoading" class="text loading-container">
            <span class="loading-dot"></span>
            <span class="loading-dot"></span>
            <span class="loading-dot"></span>
          </div>
          <!-- 否则显示文本内容 -->
          <div v-else class="text">{{ item.content }}</div>
        </div>
      </div>
      <div v-else class="bubbleBox2">
        <div class="bubble2">
          <MarkdownText
            :text="item.displayedContent || item.content"
            :is-streaming="item.isStreaming"
            :image-layout="item.isRelatedReply ? 'single' : 'grid'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MarkdownText from "@/components/MarkdownText/index.vue";

export default {
  name: "ChatBody",
  components: {
    MarkdownText,
  },
  props: {
    messages: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-body {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .message-container {
    width: 100%;
    display: flex;
    flex-direction: row;

    .bubbleBox {
      width: 100%;
      padding: 14px;
      display: flex;
      flex-direction: row-reverse;
      justify-self: flex-end;

      .bubble {
        background: linear-gradient(to right, #888bcd, #cd88cd);
        border-radius: 32px 16px 32px 32px;
        padding: 14px 16px;
        box-sizing: border-box;

        .text {
          color: #ffffff;
          font-size: 14px;
          text-align: right;
          
          &.loading-container {
            display: flex;
            gap: 6px;
            justify-content: flex-end;
            align-items: center;
            min-height: 20px;
          }
        }
      }
    }
    
    // Loading 点动画样式（与 MarkdownText 一致）
    .loading-dot {
      width: 8px;
      height: 8px;
      background-color: #ffffff;
      border-radius: 50%;
      animation: dotFlashing 1.4s infinite ease-in-out;
      
      &:nth-child(1) {
        animation-delay: 0s;
      }
      
      &:nth-child(2) {
        animation-delay: 0.2s;
      }
      
      &:nth-child(3) {
        animation-delay: 0.4s;
      }
    }

    .bubbleBox2 {
      padding: 14px;
      width: 100%;
      display: flex;

      .bubble2 {
        background-color: white;
        border-radius: 32px 32px 32px 16px;
        padding: 14px 16px;
        box-sizing: border-box;

        .text {
          color: #666666;
          font-size: 14px;
          text-align: left;
        }
      }
    }
  }
}

@keyframes dotFlashing {
  0%, 80%, 100% {
    opacity: 0.3;
  }
  40% {
    opacity: 1;
  }
}
</style>

